/**
 * Generates a random string for topic name
 */
function generateRandomTopic(): string {
  return `support-${Math.random().toString(36).substring(2, 10)}`;
}

/**
 * Gets topic name based on user email or generates random one
 */
export function getTopicName(): string {
  const userEmail = getUserEmail();
  return userEmail || generateRandomTopic();
}

/**
 * Gets user email from localStorage auth data
 */
export function getUserEmail(): string | null {
  try {
    const authData = localStorage.getItem('auth_data');
    if (!authData) return null;

    const parsed = JSON.parse(authData);
    return parsed.name || null;
  } catch (error) {
    console.error('Error parsing auth data:', error);
    return null;
  }
}
